import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IManualAddOrderFormValues,
  IManualOrderTableReport,
} from "../../Interfaces/manualInterfaces";
import {
  StepOptionOrderType,
  StepOrderSide,
} from "../../Interfaces/stepInterfaces";

interface IManualSlice {
  addOrderFormValues: IManualAddOrderFormValues | null;
  orderTableFetchDataFlag: boolean;
  tradeTableFetchDataFlag: boolean;
  editOrderRowValues: IManualOrderTableReport | null;
}

const initialState: IManualSlice = {
  addOrderFormValues: {
    stepCount: 1,
    orderSide: StepOrderSide.Buy,
    autoSellFund: false,
  } as IManualAddOrderFormValues,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
  editOrderRowValues: null,
};

const getOptionOrderType = (o?: string) => {
  if (!o) return null;
  if (o === "Open") return StepOptionOrderType.Open;
  return StepOptionOrderType.Offset;
};

const ManualOrderSlice = createSlice({
  name: "manual",
  initialState,
  reducers: {
    setManualOrderFormValues: (
      store,
      action: PayloadAction<IManualAddOrderFormValues | null>,
    ) => {
      store.addOrderFormValues = action.payload;
    },
    onManualOrderFormValuesChange: (
      store,
      action: PayloadAction<{
        name: string;
        value: any;
        name2?: string;
        value2: any;
      }>,
    ) => {
      if (action.payload.name2)
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
          [action.payload.name2]: action.payload.value2,
        } as IManualAddOrderFormValues;
      else
        store.addOrderFormValues = {
          ...store.addOrderFormValues,
          [action.payload.name]: action.payload.value,
        } as IManualAddOrderFormValues;
    },
    setManualOrderTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>,
    ) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setManualTradeTableFetchDataFlag: (
      store,
      action: PayloadAction<boolean>,
    ) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
    setManualEditRowValues: (
      store,
      action: PayloadAction<IManualOrderTableReport | null>,
    ) => {
      store.editOrderRowValues = action.payload;
    },
  },
});

export const {
  setManualOrderFormValues,
  onManualOrderFormValuesChange,
  setManualOrderTableFetchDataFlag,
  setManualTradeTableFetchDataFlag,
  setManualEditRowValues,
} = ManualOrderSlice.actions;
export default ManualOrderSlice.reducer;
